import styled from 'styled-components';
import Image from 'core/common/components/Image';

export const VideoStyled = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PosterStyled = styled(Image)`
  object-fit: cover;
  object-position: center;
`;
